import React, { useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../utils/roles';
import './Sidebar.css';

function Sidebar ({sidebarChoice}){
  console.log(`sidabare er ${sidebarChoice}`)
  const { user } = useAuth();
  const sidebarRef = useRef(null);

  // --- ANIMATIONS LOGIK ---
  const targetX = useRef(0);
  const targetY = useRef(0);
  const currentX = useRef(0);
  const currentY = useRef(0);
  const requestRef = useRef();

  useEffect(() => {
    if (sidebarRef.current) {
      const rect = sidebarRef.current.getBoundingClientRect();
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      targetX.current = centerX;
      targetY.current = centerY;
      currentX.current = centerX;
      currentY.current = centerY;
    }
  }, []);

  const handleMouseMove = (e) => {
    if (sidebarRef.current) {
      const rect = sidebarRef.current.getBoundingClientRect();
      targetX.current = e.clientX - rect.left;
      targetY.current = e.clientY - rect.top;
    }
  };

  const handleMouseLeave = () => {
    if (sidebarRef.current) {
      const rect = sidebarRef.current.getBoundingClientRect();
      targetX.current = rect.width / 100;
      targetY.current = rect.height / 100;
    }
  };

  const animate = () => {
    const ease = 0.05;
    const dx = targetX.current - currentX.current;
    const dy = targetY.current - currentY.current;
    currentX.current += dx * ease;
    currentY.current += dy * ease;

    if (sidebarRef.current) {
      sidebarRef.current.style.setProperty('--x', `${currentX.current}px`);
      sidebarRef.current.style.setProperty('--y', `${currentY.current}px`);
    }
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);

  // Helper til at oversætte rolle-koder til pænt dansk
  const getRoleLabel = (role) => {
    switch (role) {
      case ROLES.ADMIN: return 'System Administrator';
      case ROLES.SC_ADMIN: return 'Administrator';
      case ROLES.TEACHER: return 'Underviser';
      case ROLES.CENSOR: return 'Censor';
      default: return 'Bruger';
    }
  };

  // Helper til at vise skolenavnet (eller "SC-Admin" for Super Admin)
  const getHeaderTitle = () => {
    if (user?.role === ROLES.ADMIN) {
      return 'SC-Admin (SIRI)';
    }
    // Hvis schoolName findes i user-objektet (det gør det fra login), vis det.
    // Ellers fallback til "SC-Admin".
    return user?.schoolName || 'SC-Admin';
  };

  // ------------------------------------------------------

  // --- RETTIGHEDS STYRING (Granulært per side) ---

  // 1. Definer hvem der må se de enkelte links
  const canSeeClasses = user?.role === ROLES.SC_ADMIN || user?.role === ROLES.ADMIN;
  const canSeeContacts = user?.role === ROLES.SC_ADMIN || user?.role === ROLES.ADMIN;
  const canSeeStaff = user?.role === ROLES.SC_ADMIN || user?.role === ROLES.ADMIN;
  const canSeeOrgs = user?.role === ROLES.ADMIN;
  const canSeeCenters = user?.role === ROLES.ADMIN;

  // 2. Tjek om Admin-sektionen overhovedet skal vises
  // (Den vises kun, hvis man må se mindst én af tingene i den)
  const showAdminSection = canSeeClasses || canSeeContacts || canSeeStaff || canSeeOrgs || canSeeCenters;

  return (
    <aside
      className="sidebar"
      ref={sidebarRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="sidebar-header">
        <div className="sidebar-school-name">
          {getHeaderTitle()}
        </div>
        <div className="sidebar-role-label">
          {getRoleLabel(user?.role) === 'Censor' ? 'Eksaminator/censor' : 'Administrator'}
        </div>
      </div>

      <nav>
        {/* SEKTION 1: Mit Overblik (Alle har adgang) */}

        {/*
        <div className="nav-section">
          <p className="section-label">Mit Overblik</p>
          <NavLink to="/dashboard" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            Dashboard
          </NavLink>

        </div>
        */}

        {/* CENSOR / UNDERVISER MENU */}
        {user?.role === ROLES.CENSOR && (
          <div className="nav-section">
            <p className="section-label">Eksaminator/Censor</p>

            {/*}
            <NavLink to="/my-exams" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Mine tildelinger
            </NavLink> */}

            <NavLink to="/my-exams-download" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Download af prøver
            </NavLink>

            <NavLink to="/my-exams-upload" className={({isActive})=> isActive ? "nav-link active": "nav-link"}>
              Upload af filer
            </NavLink>

            <NavLink to="/my-censor-data" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Mine stamdata
            </NavLink>

          {/*}
            <NavLink to="/my-appointment" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Min beskikkelse
            </NavLink>*/}
          </div>
        )}

        {
        /* user?.role === ROLES.CENSOR && (
          <div className="nav-section">
            <p className="section-label">Karaktergivning</p>
            <NavLink to="/my-teacherexamlist" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
               Karakterlister som eksaminator
            </NavLink>
            <NavLink to="/my-assessorexamlist" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
               Karakterlister som censor
            </NavLink>
            <NavLink to="/my-finalexamlist" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
               Endelig karaktergivning som censor
            </NavLink>

          </div>
        ) */
        }

        {/* SEKTION 2: Administration (Vises kun hvis man har mindst én rettighed) */}
        {sidebarChoice === 'censorAdm' && showAdminSection && (
          <div className="nav-section">
            <p className="section-label">Administration</p>

            {/* Hvert link er pakket ind i sin egen betingelse */}

        {/*
            {canSeeOrgs && (
              <NavLink to="/organisations" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Organisationer
              </NavLink>
            )}

            {canSeeCenters && (
              <NavLink to="/language-centers" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Sprogcentre
              </NavLink>
            )}

            {canSeeContacts && (
              <NavLink to="/contacts" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Kontaktpersoner
              </NavLink>
            )}

            {canSeeStaff && (
              <NavLink to="/staff" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Undervisere & Censorer
              </NavLink>
            )}

          */}

            {canSeeContacts && (
              <NavLink to="/users" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Brugere & Logins
              </NavLink>
            )}

          </div>
        )}

        {/* SEKTION 3: Censorfordeling (Vises for SC_ADMIN og ADMIN) */}
        {/*(sidebarChoice === 'censorAdm' && (user?.role === ROLES.SC_ADMIN || user?.role === ROLES.ADMIN)) && (
          <div className="nav-section">
            <p className="section-label">Censorfordeling</p>

            {canSeeClasses && (
              <NavLink to="/classes" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Indberet prøvedeltagere
              </NavLink>
            )}

            <NavLink to="/allocation/outgoing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Egne Censorer
            </NavLink>

            <NavLink to="/allocation/incoming" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Udefra Censorer
            </NavLink>
          </div>
        )
        
        */}
        {/* Student admin*/}
        {(sidebarChoice ==='studentAdm') && (
          <>
          <div className="nav-section">
            <p className="section-label">Kursistadministration</p>
            <NavLink to="/studentcreation" className={({isActive})=> isActive? "nav-link active": "nav-link"}>
              Opret kursister
            </NavLink>
          </div>
          <div className="nav-section">
            <p className="section-label">Holdadministration</p>
            <NavLink to="/studentclassadmin" className={({isActive}) => isActive? "nav-link active": "nav-link"}>
              Opret/ret hold
            </NavLink>
            <NavLink to="/studentclassstudentadmin" className={({isActive}) => isActive? "nav-link active": "nav-link"}>
              Administre holddeltagere
            </NavLink>
          </div>
          </>
        )}

        {/* exam admin*/}
        {(sidebarChoice ==='examAdm') &&(
          <>
            <div className="nav-section">
              <p className="section-label">Prøvegruppeadministration</p>
              <NavLink to="/testgroupadmin" className={({isActive}) =>isActive? "nav-link active": "nav-link"}>
                Opret/ret prøvegrupper
              </NavLink>
              <NavLink to="/studenttestgroupadmin" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
                Administrer prøvegruppedeltagere
              </NavLink>
              <NavLink to="/uploadexams" className={({isActive})=> isActive? "nav-link active" : "nav-link"}>
                Upload skriftlige prøver
              </NavLink>
            </div>
            <div className="nav-section">
              <p className="section-label">Sprogcentrets modtagne prøver</p>
              <NavLink to="/receivedexams" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
                 Modtagne prøver
              </NavLink>
            </div>
            <div className="nav-section">
              <p className="section-label">Sprogcentrets udsendte prøver</p>
              <NavLink to="/dispatchedexams" className={({isActive}) => isActive? "nav-link active" : "nav-link"}>
                 Udsendte prøver
              </NavLink>
            </div>
          </>
        )}

        {/* SEKTION: Hjælp (Alle har adgang) */}
        <div className="nav-section">
          <p className="section-label">Hjælp</p>
          <NavLink to="/help" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
            Vejledninger
          </NavLink>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;